/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement, noShadowDOM } from 'solid-element';
import CustomTextarea, { type CustomTextareaProps } from './CustomTextarea';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-custom-textarea': Partial<HTMLElement> &
        CustomTextareaProps &
        Partial<{ ref: any }>;
    }
  }
}

export function defineSolidCustomTextarea(): void {
  customElement(
    'tc-custom-textarea',
    {
      name: undefined as unknown as string,
      label: undefined as unknown as string,
      setFocus: false,
      id: undefined as unknown as string | undefined,
      value: undefined as unknown as string | undefined,
      placeholder: undefined as unknown as string | undefined,
      disabled: false,
      readonly: false,
      required: false,
      rows: undefined as unknown as number | undefined,
      maxLength: undefined as unknown as number | undefined,
      'data-cy': undefined as unknown as string | undefined,
      dataCy: undefined as unknown as string | undefined,
      error: undefined as unknown as string | undefined,
      touched: false,
      onInput: undefined as unknown as CustomTextareaProps['onInput'],
      onChange: undefined as unknown as CustomTextareaProps['onChange'],
      onBlur: undefined as unknown as CustomTextareaProps['onBlur'],
      onFocus: undefined as unknown as CustomTextareaProps['onFocus'],
    },
    (props) => {
      noShadowDOM();
      return <CustomTextarea {...props} />;
    }
  );
}

export type { CustomTextareaProps };
